var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"bg-theme text-theme font-sans"},[_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }